import React from 'react';
import { remCalc } from '../../../util/style-util';
import chevronPath from 'assets/images/resources/chevron.svg';
import { makeStyles } from '@mui/styles';

type Props = {
  onClick: () => void;
  open: boolean;
  accessibilityLabelButton: (boolean) => string;
};

const ArrowDropdown = ({ onClick, open, accessibilityLabelButton }: Props) => {
  const classes = useStyles()({ open });

  return (
    <div
      className={classes.arrowContainer}
      onClick={onClick}
      role="button"
      aria-label={accessibilityLabelButton(open)}
      aria-pressed={open}
    >
      <img className={classes.icon} alt="-" src={chevronPath} />
    </div>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    icon: ({ open }: any) => ({
      width: remCalc(20),
      transform: open ? 'rotate(180deg)' : 'rotate(0)',
      transformOrigin: 'center center',
      transition: 'transform 300ms linear'
    }),
    arrowContainer: {
      position: 'absolute',
      display: 'flex',
      width: '80%',
      height: remCalc(20),
      right: remCalc(10),
      top: remCalc(10),
      cursor: 'pointer',
      justifyContent: 'flex-end',
      paddingRight: remCalc(15),
      userSelect: 'none'
    }
  }));

export default ArrowDropdown;
